import { useForm } from 'antd/lib/form/Form';
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import { useState } from 'react';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { getBuildingUrl } from 'services/navigation';
import { createBuilding } from 'services/api';
import type { BuildingFormValues, BuildingModalProps } from '../types';
import { BuildingFooter } from '../Footer/BuildingFooter';
import { BuildingForm } from '../../Form/BuildingForm';

export const CreateBuildingModal = ({ visible, hide }: BuildingModalProps) => {
  const [form] = useForm<BuildingFormValues>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      createBuilding(values)
        .then((res) => {
          hideModal();
          navigate(getBuildingUrl({ buildingId: res.id.toString() }));
        })
        .catch((error) => {
          notification.error({ message: 'Не удалось создать здание' });
          throw error;
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const hideModal = () => {
    hide();
    form.resetFields();
  };

  const footer = <BuildingFooter onSubmit={onSubmit} hideModal={hideModal} title="Создать" />;
  const content = <BuildingForm form={form} />;

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Создать здание"
      maskClosable={false}
    />
  );
};
